import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initSentry } from './lib/sentry';
// Tipografía del mock (mockups/_shared/tokens.css): Inter, self-hosted (sin CDN externo).
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';

initSentry();

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');
createRoot(root).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
